import { useState } from "react";
import type { ReactNode } from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "@/design-system/lib/utils";

interface CollapsibleSectionProps {
  title: string;
  warning?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
}

export function CollapsibleSection({
  title,
  warning,
  defaultOpen = false,
  children,
}: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="bg-white-pure rounded-lg border border-border-light">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-space-3 px-space-4 py-space-3 text-left"
      >
        <div>
          <h3 className="font-display font-bold text-small uppercase tracking-wider text-gold-shadow m-0">
            {title}
          </h3>
          {warning && <div className="text-caption text-gray-mid mt-space-1">{warning}</div>}
        </div>
        <ChevronRight
          size={16}
          strokeWidth={1.5}
          aria-hidden
          className={cn("text-gold-shadow transition-transform", open && "rotate-90")}
        />
      </button>
      {open && <div className="px-space-4 pb-space-4">{children}</div>}
    </section>
  );
}
